// src/App.js
import React, {useState} from 'react';
import {BrowserRouter as Router} from "react-router-dom";
import MainPage from "./pages/MainPage";
import LoginPage from './comps/LoginPage';
import './style/css/main.css'
import managecookies from "./services/managecookies";

function App(props) {
    const [isAuthenticated, setIsAuthenticated] = useState(managecookies.getCookieVal('loginKey'));

    const handleLogin = async (res) => {
        console.log('login',res);
        await managecookies.setCookie('authToken', res.data.token, 8) // בדיקת הרשאה
        await managecookies.setCookie('busiToken', res.data.business.length > 0 ? res.data.business[0].businessToken : null, 8) // בדיקת הרשאת עסק
        await managecookies.setCookie('userData', JSON.stringify(res.data), 8) // בדיקת שיוך התראה
        await managecookies.setCookie('loginKey', true, 8) // האם מחובר
        setIsAuthenticated(true);
    };

    return (
        <Router>
            {isAuthenticated ? <MainPage/> : <LoginPage onLogin={handleLogin}/>}
        </Router>
    );
}

export default App;
